
module.exports = function(angularModule) {
  angularModule.service('RGContactUploadService', function ($uibModal) {

    this.open = function() {
      $uibModal.open({
        controller: 'ContactUploadCtrl',
        template: require('./contactUpload.html'),
        resolve: {
          campaign: null
        },
        size: 'lg'
      });
    }
  });
};
